import { useState } from "react";
import { Row } from "../../../../components/Row";
import { Input } from "../../../../components/Input";
import { Button, ChevronIcon, Divider, Field, Label, Toggle } from "../../../../components/Forms";
import styled from "styled-components";
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import { Accordion } from "../../../../components/Accordion";
import {indices} from "../../../../mocks/indices"
import { TreeSelect } from "../../../../components/TreeSelect";
import useAnalyticsEventTracker from '../../../../hooks/useAnalyticsEventTracker';

interface paramsProps {
  submit(value: any, page: number): void;
}

export function Form({ submit }: paramsProps) {
  const gaEventTracker = useAnalyticsEventTracker('Blog Form');

  const [buscaLivre, setLivre] = useState('');
  const [autor, setAutor] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [index, setIndex] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);

  async function onSubmit(e: any) {
    e.preventDefault();
    await search();
  }

  async function search() {
    const search_temp = {
      buscaLivre: buscaLivre,
      author: autor,
      initialDate: initialDate? `${initialDate}-01-01`: '',
      finalDate: finalDate? `${finalDate}-12-31` : '',
      index: index,
    };
    gaEventTracker('submit', JSON.stringify(search_temp))

    await submit(search_temp, 1);
  }
  
  function maskInitialYear(value: string, setYear: Function) {
    if(Number.isNaN(Number(value))) return;
    if(Number(value) < 0) return;
    if(value.length > 4) return;
    
    if(finalDate && value >= finalDate) {
      setFinalDate(`${Number(value) + 1}`);
    }

    setYear(value);
  }

  function maskFinalYear(value: string, setYear: Function) {
    if(Number.isNaN(Number(value))) return;
    if(Number(value) < 0) return;
    if(value.length > 4) return;

    setYear(value);
  }

  return (
    <DirectionChanger>
      <CustomToggle onClick={() => setIsFormOpen(!isFormOpen)} customWidth="100%" margin="auto">
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </CustomToggle>
      <CustomAccordion isOpen={isFormOpen} margin="0">
        <Content
          onSubmit={onSubmit}
        >
          <Label>Busca Livre</Label>
          <Input
            type="text"
            placeholder="Pesquisar"
            marginBottom="16px"
            value={buscaLivre}
            onChange={(value) => setLivre(value)}
          />
          <Label>Intervalo de Datas</Label>
          <Row breakOnMobile={false}>
            <Field marginBottom="6px">
              <Input
                type={'text'}
                placeholder="Inicial"
                maxWidth="95px"
                value={initialDate}
                onChange={(value: any) => maskInitialYear(value, setInitialDate)}
              />
            </Field>
            <Divider>A</Divider>
            <Field marginBottom="6px">
              <Input
                type={'text'}
                placeholder="Final"
                maxWidth="95px"
                marginBottom="16px"
                value={finalDate}
                onChange={(value: any) => maskFinalYear(value, setFinalDate)}
              />
            </Field>
          </Row>
          <Label>Autor/Organização</Label>
          <Input
            type="text"
            placeholder=""
            marginBottom="16px"
            value={autor}
            onChange={(value) => setAutor(value)}
          />
          <Label>Índice</Label>
          <CustomField marginBottom="16px">
            <TreeSelect
              data={indices} 
              marginBottom="0px"
              dropdownMaxHeight="600px"
              value={index}
              onChange={(value: any) => setIndex(value)}
            />
            <ChevronIcon size={24} />
          </CustomField>
          <Button>Pesquisar</Button>
        </Content>
      </CustomAccordion>
    </DirectionChanger>
  );
}

const DirectionChanger = styled.div`
  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    flex-direction: column;
    margin-bottom: 32px;
    width: 100%;
  }
`;

const Content = styled.form`
  display: flex;
  flex-direction: column;
  padding: 32px 0 0;
  position: relative;
  border: ${({ theme }) => `1px solid ${theme.colors.blue.dark}`};
  border-radius: 16px;
  padding: 32px 32px 64px;
  margin-top: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: 100%;
    margin: auto;
    padding: 14px 0 20px;
    border: none;
    border-radius: 0;
  }
`;

const CustomToggle = styled(Toggle)`
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) and (min-width: ${({ theme }) => theme.device.mobile}) {
    display: none;
  }
`;

const CustomAccordion = styled(Accordion)`
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) and (min-width: ${({ theme }) => theme.device.mobile}) {
    width: calc(40vw - 32px);
    overflow: visible;
    margin: 0;
    transition: none;
    border: none;
  }
`;

const CustomField = styled(Field)`
  max-width: 231px;
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    max-width: none;
  }

`;